import { Route, Routes } from "react-router-dom";
import ErrorPage from "../Error/ErrorPage";
import Kart from "./components/kart/Kart";
import FellingsInfo from "./Fellingsinfo/Fellingsinfo";
import EndreJaktdag from "./Jaktdag/EndreJaktdag";
import RegistrerElg from "./Jaktdag/RegistrerElg/RegistrerElg";
import RegistrerHjort from "./Jaktdag/RegistrerHjort/RegistrerHjort";
import RegistrerRadyr from "./RegistrerRadyr/RegistrerRadyr";
import RegistrerVillrein from "./RegistrerVillrein/RegistrerVillrein";
import VelgArt from "./VelgArt";

export default function Registrering(): JSX.Element {
  return (
    <Routes>
      <Route index element={<VelgArt />} />
      <Route path="fellingsinfo/:individId" element={<FellingsInfo />} />
      <Route path="jaktdag/:jaktdagId" element={<EndreJaktdag />} />
      <Route path="elg" element={<RegistrerElg />} />
      <Route path="hjort" element={<RegistrerHjort />} />
      <Route path="radyr" element={<RegistrerRadyr />} />
      <Route path="villrein" element={<RegistrerVillrein />} />
      <Route path="kart" element={<Kart />} />
      <Route path="/*" element={<ErrorPage />} />
    </Routes>
  );
}
